import { resetOembedId } from './ResetOembedId';
import { resetOembedUrl } from './ResetOembedUrl';
import { resetOembedIsBusy } from './ResetOembedIsBusy';

export const resetOembed = () => {
	resetOembedId();
	resetOembedUrl();
	resetOembedIsBusy();
};
